import { LinkContext } from '@anm/contexts/LinkContext';
import { useContext, FC } from 'react';
import styled from 'styled-components';

export const LinkWrapper = styled.div`
  display: inline;
`;

export const DuplicateActionTooltip = styled.div`
  min-width: 205px;
  ${LinkWrapper} {
    a {
      min-height: unset;
      display: inline;
      padding: 0;
      opacity: 1;
      line-height: inherit;
      color: var(--blue_100);
      &:hover {
        text-decoration: underline;
        background-color: transparent;
      }
    }
  }
`;

const DuplicateTooltipContent: FC = () => {
  const { Link } = useContext(LinkContext);
  return (
    <DuplicateActionTooltip>
      To duplicate your projects, please&nbsp;
      <LinkWrapper>
        <Link route="pricing">upgrade</Link>
      </LinkWrapper>
    </DuplicateActionTooltip>
  );
};

export default DuplicateTooltipContent;
